import { render, staticRenderFns } from "./infoForm.vue?vue&type=template&id=b5c2dbe8&scoped=true"
import script from "./infoForm.vue?vue&type=script&lang=js"
export * from "./infoForm.vue?vue&type=script&lang=js"
import style0 from "./infoForm.vue?vue&type=style&index=0&id=b5c2dbe8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c2dbe8",
  null
  
)

export default component.exports